import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import dashboardReducer from "./dashboardSlice";
import tasksReducer from "./tasksSlice";
import resetPassReducer from "./resetPassSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    dashboard: dashboardReducer,
    tasks: tasksReducer,
    reset: resetPassReducer,
  },
});
